import ActiveSymbols from './activeSymbols';
import config from '../../common/const';
import { getObjectValue } from '../../../common/utils/tools';

const noop = () => {};

let parsedAssetIndex;

const parseAssetIndex = assetIndex => {
    const parsed = {};

    assetIndex.forEach(symbol => {
        parsed[symbol[0].toLowerCase()] = {};

        symbol[2].forEach(category => {
            [, , parsed[symbol[0].toLowerCase()][category[0].toLowerCase()]] = category;
        });
    });
    return parsed;
};

const getAllowedConditionsOrCategoriesForSymbol = symbol => {
    let conditions = [];
    const categories = [];
    // New Options API has no asset_index (parsedAssetIndex stays empty): allow every category,
    // otherwise every market looks unavailable (same guard as binaryblocks).
    if (!parsedAssetIndex || Object.keys(parsedAssetIndex).length === 0) {
        Object.keys(config.conditionsCategory).forEach(conditionName => {
            conditions = conditions.concat(config.conditionsCategory[conditionName]);
            categories.push(conditionName);
        });
        return { conditions, categories };
    }
    const index = parsedAssetIndex[symbol.toLowerCase()];
    if (index) {
        Object.keys(config.conditionsCategory).forEach(conditionName => {
            if (conditionName in index) {
                conditions = conditions.concat(config.conditionsCategory[conditionName]);
                categories.push(conditionName);
            }
        });
    }
    return { conditions, categories };
};

const getCategoryForCondition = condition =>
    Object.keys(config.conditionsCategory).find(
        category => config.conditionsCategory[category].indexOf(condition.toLowerCase()) >= 0
    );

export default class _Symbol {
    constructor(api) {
        this.api = api;
        this.initPromise = new Promise(resolve => {
            const getActiveSymbolsLogic = () => {
                this.api.getActiveSymbolsBrief().then(r => {
                    if (!r || !Array.isArray(r.active_symbols)) {
                        resolve();
                        return;
                    }
                    this.activeSymbols = new ActiveSymbols(r.active_symbols);
                    this.api.getAssetIndex().then(r2 => {
                        parsedAssetIndex = parseAssetIndex(r2.asset_index);
                        resolve();
                    }, err => {
                        console.error('[symbolApi] getAssetIndex FAILED:', err && err.message, err);
                        parsedAssetIndex = {};
                        resolve();
                    });
                }, noop);
            };
            // In v4, authentication is tied to the connection URL.
            // Just connect and fetch.
            this.api
                .connect()
                .then(() => getActiveSymbolsLogic())
                .catch(() => getActiveSymbolsLogic());
        });
    }
    /* eslint-disable class-methods-use-this */
    getLimitation(symbol, condition) {
        const category = getCategoryForCondition(condition);
        const index = parsedAssetIndex && parsedAssetIndex[symbol.toLowerCase()];
        return {
            minDuration: index ? index[category] : undefined,
        };
    }
    isConditionAllowedInSymbol(symbol, condition) {
        const { conditions } = getAllowedConditionsOrCategoriesForSymbol(symbol);
        return conditions.includes(condition);
    }
    getConditionName(condition) {
        const [con1, con2] = config.opposites[condition.toUpperCase()];
        return `${getObjectValue(con1)}/${getObjectValue(con2)}`;
    }
    getCategoryNameForCondition(condition) {
        return config.conditionsCategoryName[getCategoryForCondition(condition)];
    }
    getAllowedCategories(symbol) {
        return getAllowedConditionsOrCategoriesForSymbol(symbol).categories;
    }
    getAllowedCategoryNames(symbol) {
        const { categories } = getAllowedConditionsOrCategoriesForSymbol(symbol);
        return categories.map(el => config.conditionsCategoryName[el]);
    }
    /* eslint-enable */
}
